import NextImage from 'next/legacy/image';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { AspectRatioBox, Box, prefixUrl } from '@miro-site/core';
import { BoardEmbed } from '@miro-site/ui-board-embed';
import TransparentButton from '../../button/TransparentButton';
import { Search } from '../../icons/Icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var PreviewIcon = styled(Search).withConfig({
  displayName: "BoardEmbedPreview__PreviewIcon",
  componentId: "sc-1xkpy7v-0"
})(["", ""], function (props) {
  return props.theme.normalizeStyles({
    marginRight: 10
  });
});
var PreviewButton = styled(TransparentButton).attrs({
  $size: 'medium'
}).withConfig({
  displayName: "BoardEmbedPreview__PreviewButton",
  componentId: "sc-1xkpy7v-1"
})(["background:", ";"], function (props) {
  return props.theme.colors.primaryWhite;
});
var previewVisibleStyles = css(["transition:opacity 0.25s linear;opacity:1;"]);
var PreviewContainer = styled(Box).attrs({
  $styles: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    transition: 'opacity 0.25s linear',
    opacity: 0,
    background: 'rgba(var(--wcds-colors-indigo-90-rgb), 0.2)'
  }
}).withConfig({
  displayName: "BoardEmbedPreview__PreviewContainer",
  componentId: "sc-1xkpy7v-2"
})(["", "{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);}&:focus-within{", "}"], PreviewButton, previewVisibleStyles);
var EmbedContainer = styled(AspectRatioBox).withConfig({
  displayName: "BoardEmbedPreview__EmbedContainer",
  componentId: "sc-1xkpy7v-3"
})(["cursor:pointer;&:hover ", "{", "}"], PreviewContainer, previewVisibleStyles);

var BoardEmbedPreview = function BoardEmbedPreview(props) {
  var boardKey = props.boardKey,
      imageSrc = props.imageSrc,
      imageName = props.imageName;

  var _useState = useState(false),
      isEmbedVisible = _useState[0],
      setEmbedVisible = _useState[1];

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(EmbedContainer, {
    "data-testid": "board-embed-preview-container",
    $width: 720,
    $height: 480,
    onClick: function onClick() {
      setEmbedVisible(true);
    },
    children: isEmbedVisible ? /*#__PURE__*/_jsx(BoardEmbed, {
      boardId: boardKey
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NextImage, {
        src: prefixUrl(imageSrc),
        unoptimized: true,
        alt: imageName,
        priority: true,
        layout: "fill"
      }), /*#__PURE__*/_jsx(PreviewContainer, {
        children: /*#__PURE__*/_jsx(PreviewButton, {
          children: /*#__PURE__*/_jsxs(Box, {
            $styles: {
              display: 'flex',
              flexFlow: 'row nowrap',
              alignItems: 'center'
            },
            children: [/*#__PURE__*/_jsx(PreviewIcon, {
              width: 24,
              height: 24
            }), t('templates-actions-preview')]
          })
        })
      })]
    })
  });
};

export default BoardEmbedPreview;